export default __webpack_public_path__ + "static/media/white-flowers-r.8f42fbc2.svg";